module.exports = __webpack_public_path__ + "static/media/search-circle.41933f43.svg";